import { Module } from 'vuex';
import { PricingService } from '@/app/services/PricingService';
import { SettingService } from '@/app/services/SettingService';
import { SelfServiceModeService } from '@/app/services/SelfServiceModeService';
import { CompanyService } from '@/app/services/CompanyService';
import { ContactService } from '@/app/services/ContactService';
import { ConsumerProfileService } from '@/app/services/ConsumerProfileService';
import { DeleteAccountService } from '@/app/services/DeleteAccountService';
import { State } from '@/store';
import { ModuleState, createState } from './state';
import { createGetters } from './getters';
import { createMutations } from './mutations';
import { createActions } from './actions';
import { UserPermissions } from '../services/UserPermissionsService';

export interface StoreModule extends Module<ModuleState, State> {}

export function createStoreModule(
  pricingService: PricingService,
  settingService: SettingService,
  selfServiceModeService: SelfServiceModeService,
  companyService: CompanyService,
  contactService: ContactService,
  consumerProfileService: ConsumerProfileService,
  deleteAccountService: DeleteAccountService,
  userPermissions: UserPermissions
): StoreModule {
  return {
    namespaced: true,
    state: createState(userPermissions),
    getters: createGetters(),
    mutations: createMutations(),
    actions: createActions(
      pricingService,
      settingService,
      selfServiceModeService,
      companyService,
      contactService,
      consumerProfileService,
      deleteAccountService
    )
  };
}
